import { Component, input, ChangeDetectionStrategy, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil, startWith } from 'rxjs';
import { ValidationMessageComponent } from '@components/traffic-deviations/components/validation-message/validation-message.component';

@Component({
  selector: 'app-form-time',
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, ValidationMessageComponent],
  templateUrl: './form-time.component.html',
  styleUrls: ['./form-time.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormTimeComponent implements OnInit, OnDestroy {
  control = input.required<FormControl<string>>();
  label = input<string>('');
  readonly = input<boolean>(false);
  id = input<string>('');
  showValidation = input<boolean>(true);
  preValidate = input<boolean>(true);

  private readonly _destroy$ = new Subject<void>();

  ngOnInit(): void {
    if (this.preValidate()) {
      this.control().valueChanges.pipe(
        startWith(this.control().value),
        takeUntil(this._destroy$)
      ).subscribe(() => {
        this.control().markAsTouched();
      });
    }
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  protected get shouldShowError(): boolean {
    const ctrl = this.control();
    const shouldShow = this.showValidation() && ctrl.invalid;
    
    if (this.preValidate()) {
      return shouldShow;
    }
    
    return shouldShow && (ctrl.dirty || ctrl.touched);
  }

  protected onKeydownPicker(event: KeyboardEvent, elementRef: HTMLInputElement): void {
    if (event.code === 'Enter' || event.code === 'Space') {
      event.preventDefault();
      elementRef.showPicker?.();
    }
  }
}
